import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { I18nProvider } from "@/context/I18nContext";
import { PeriodProvider } from "@/context/PeriodContext";
import { Toaster } from "@/components/ui/sonner";

import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Finance from "@/pages/Finance";
import Inventory from "@/pages/Inventory";
import Staff from "@/pages/Staff";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminTenants from "@/pages/admin/AdminTenants";
import AdminTenantDetail from "@/pages/admin/AdminTenantDetail";
import SupportModeBanner from "@/components/SupportModeBanner";
import CopilotPage from "@/pages/Copilot";
import ForecastPage from "@/pages/Forecast";
import ImportsPage from "@/pages/Imports";
import HQDashboard from "@/pages/HQDashboard";
import CopilotFab from "@/components/copilot/CopilotFab";

// Legacy POS pages — kept in the codebase for future reactivation, not linked from nav.
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Menu from "@/pages/Menu";
import Tables from "@/pages/Tables";
import KDS from "@/pages/KDS";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <PeriodProvider>
        <BrowserRouter>
          <SupportModeBanner />
          <CopilotFab />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<AdminOverview />} />
              <Route path="tenants" element={<AdminTenants />} />
              <Route path="tenants/:restaurantId" element={<AdminTenantDetail />} />
            </Route>
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/finance" element={<Finance />} />
              <Route path="/inventory" element={<Inventory />} />
              <Route path="/staff" element={<Staff />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/copilot" element={<CopilotPage />} />
              <Route path="/forecast" element={<ForecastPage />} />
              <Route path="/imports" element={<ImportsPage />} />
              <Route path="/hq" element={<HQDashboard />} />
              {/* legacy — accessible by direct URL only */}
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/menu" element={<Menu />} />
              <Route path="/tables" element={<Tables />} />
              <Route path="/kds" element={<KDS />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
        </PeriodProvider>
      </AuthProvider>
    </I18nProvider>
  );
}
